document.addEventListener('DOMContentLoaded', function() {
  // Set initial active_index class on gallery for all product items
  document.querySelectorAll('.product-item').forEach(item => {
    const gallery = item.querySelector('.product-item__gallery');
    if (gallery) {
      gallery.classList.add('active_index');
    }

    // Make sure the main image doesn't have the active_index class
    const mainImage = item.querySelector('.product-item__bg');
    if (mainImage) {
      mainImage.classList.remove('active_index');
    }
  });

  // Initialize image sliders
  initProductImageSliders();

  // Initialize color swatches
  initColorSwatches();

  // Initialize swipe functionality
  initGallerySwipe();
});

// Hydrate a deferred gallery image placeholder with a real <img>
function hydrateDeferredImage(el) {
  if (!el.classList.contains('gallery-image--deferred')) return;

  const src = el.getAttribute('data-deferred-src');
  const srcset = el.getAttribute('data-deferred-srcset');
  const sizes = el.getAttribute('data-deferred-sizes');
  const alt = el.getAttribute('data-deferred-alt') || '';

  if (!src) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'image-wrapper lazy-image';

  const img = document.createElement('img');
  img.src = src;
  if (srcset) img.srcset = srcset;
  if (sizes) img.sizes = sizes;
  img.alt = alt;
  img.loading = 'lazy';
  img.decoding = 'async';
  img.className = 'image__img';

  wrapper.appendChild(img);
  el.appendChild(wrapper);
  el.classList.remove('gallery-image--deferred');
}

function initProductImageSliders() {
  // Use event delegation on document for all gallery buttons
  const grid = document.querySelector('#CollectionLoop') || document.body;

  // Single delegated click listener
  grid.addEventListener('click', function(e) {
    const navButton = e.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (!navButton) return;

    e.preventDefault();
    e.stopPropagation();

    handleGalleryNavigation(navButton);
  });
}

function handleGalleryNavigation(navButton) {
  const productItem = navButton.closest('.product-item');
  const gallery = productItem.querySelector('.product-item__gallery');
  const mainProductImage = productItem.querySelector('.product-item__bg');
  const lifestyleImage = productItem.querySelector('.product-item__bg__under.product-lifestyle-image');
  const videoContainer = productItem.querySelector('.product-video-container');

  // Disable lifestyle images and videos for this product item
  productItem.setAttribute('data-lifestyle-disabled', 'true');

  // Clear any existing timer
  if (productItem.lifestyleTimer) {
    clearTimeout(productItem.lifestyleTimer);
  }

  // Re-enable after 10 seconds
  productItem.lifestyleTimer = setTimeout(() => {
    productItem.removeAttribute('data-lifestyle-disabled');
    delete productItem.lifestyleTimer;
  }, 10000);

  // Remove active class from lifestyle image
  if (lifestyleImage && lifestyleImage.classList.contains('active')) {
    lifestyleImage.classList.remove('active');
  }

  // Remove active class from video container
  if (videoContainer && videoContainer.classList.contains('active')) {
    videoContainer.classList.remove('active');
  }

  // Toggle active_index class
  if (mainProductImage.classList.contains('active_index')) {
    mainProductImage.classList.remove('active_index');
    gallery.classList.add('active_index');
  }

  const images = gallery.querySelectorAll('.product-item__gallery-image');
  const currentActive = gallery.querySelector('.active');
  let currentIndex = Array.from(images).indexOf(currentActive);
  let newIndex;

  // Determine direction
  if (navButton.hasAttribute('data-gallery-prev')) {
    newIndex = (currentIndex - 1 + images.length) % images.length;
  } else {
    newIndex = (currentIndex + 1) % images.length;
  }

  // Hydrate and update
  hydrateDeferredImage(images[newIndex]);
  currentActive.classList.remove('active');
  images[newIndex].classList.add('active');
}

// Color swatches now handled by collection-color-swatches.js (fetch on click)

function initColorSwatches() {
  // Handle sibling swatches only (color swatches use fetch-on-click in collection-color-swatches.js)
  const siblingSwatches = document.querySelectorAll('[data-sibling-link]');
  siblingSwatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const productGridItem = this.closest('[data-product-grid-item]');
      if (!productGridItem) return;

      // Update active state
      const allSiblingSwatches = productGridItem.querySelectorAll('.siblings__link');
      allSiblingSwatches.forEach(s => s.classList.remove('siblings__link--current'));
      this.closest('.siblings__link').classList.add('siblings__link--current');

      // Get data
      const siblingUrl = this.getAttribute('data-sibling-link');
      const siblingPrice = this.getAttribute('data-sibling-price');
      const siblingCutline = this.getAttribute('data-sibling-cutline');
      const siblingImage = this.getAttribute('data-sibling-image');

      // Toggle active_index class
      const mainImageContainer = productGridItem.querySelector('[data-product-image-default]');
      const galleryContainer = productGridItem.querySelector('.product-item__gallery');

      if (mainImageContainer) {
        mainImageContainer.classList.add('active_index');
        if (galleryContainer) {
          galleryContainer.classList.remove('active_index');
        }
      }

      // Update product link
      const productLinks = productGridItem.querySelectorAll('[data-product-link]');
      productLinks.forEach(link => {
        link.setAttribute('href', siblingUrl);
      });

      // Update price
      const priceElement = productGridItem.querySelector('[data-product-price] .price');
      if (priceElement && siblingPrice) {
        priceElement.innerHTML = `<span class="new-price">${siblingPrice}</span>`;
      }

      // Update cutline
      const cutlineElement = productGridItem.querySelector('[data-product-cutline]');
      if (cutlineElement && siblingCutline) {
        cutlineElement.textContent = siblingCutline;
      }

      // Update sibling image
      const siblingImageElement = productGridItem.querySelector('[data-product-image-sibling]');
      if (siblingImageElement && siblingImage) {
        siblingImageElement.style.backgroundImage = `url(${siblingImage})`;
        siblingImageElement.style.display = 'block';
      }
    });
  });
}

// Gallery Swipe Functionality
function initGallerySwipe() {
  const productItems = document.querySelectorAll('.product-item');
  const SWIPE_THRESHOLD = 30;

  productItems.forEach((item) => {
    const gallery = item.querySelector('.product-item__gallery');
    if (!gallery) return;

    const images = gallery.querySelectorAll('.product-item__gallery-image');
    if (images.length <= 1) return;

    const galleryNav = item.querySelector('.product-item__gallery-nav');
    if (!galleryNav) return;

    // Bind to the full image area, not .product-item__gallery-nav - that
    // element is `pointer-events: none` (collection_img_slider.css) except
    // for its two small 44px arrow buttons, so a swipe starting anywhere
    // else on the image never reached these listeners before.
    const swipeTarget = item.querySelector('.product-item__image');
    if (!swipeTarget) return;

    const productLink = item.querySelector('.product-link');

    let startX = 0;
    let startY = 0;
    let isTouching = false;
    let didSwipe = false;

    function getX(e) {
      return e.type.includes('mouse') ? e.pageX :
        (e.touches?.[0]?.clientX || e.changedTouches?.[0]?.clientX || 0);
    }

    function getY(e) {
      return e.type.includes('mouse') ? e.pageY :
        (e.touches?.[0]?.clientY || e.changedTouches?.[0]?.clientY || 0);
    }

    function navigateGallery(direction) {
      // Find the appropriate nav button and use the shared handler
      const navButton = direction === 'prev'
        ? galleryNav.querySelector('[data-gallery-prev]')
        : galleryNav.querySelector('[data-gallery-next]');

      if (navButton) {
        handleGalleryNavigation(navButton);
      }
    }

    function handleStart(e) {
      isTouching = true;
      didSwipe = false;
      startX = getX(e);
      startY = getY(e);
    }

    function handleEnd(e) {
      if (!isTouching) return;
      isTouching = false;

      const diffX = getX(e) - startX;
      const diffY = getY(e) - startY;

      // Ignore mostly-vertical drags so page scroll isn't hijacked
      if (Math.abs(diffX) > SWIPE_THRESHOLD && Math.abs(diffX) > Math.abs(diffY)) {
        didSwipe = true;
        // Stop the tap-through link navigation this swipe would otherwise trigger
        e.preventDefault();
        navigateGallery(diffX < 0 ? 'next' : 'prev');
      }
    }

    swipeTarget.addEventListener('touchstart', handleStart, { passive: true });
    swipeTarget.addEventListener('touchend', handleEnd);

    swipeTarget.addEventListener('mousedown', handleStart);
    swipeTarget.addEventListener('mouseup', handleEnd);
    swipeTarget.addEventListener('mouseleave', () => {
      isTouching = false;
    });

    // Belt-and-braces: some mobile browsers still fire a synthetic click
    // after touchend even when preventDefault was called on it, since the
    // click target (the <a>) is a different element than the touchend
    // target. Swallow that one click if we just navigated via swipe.
    if (productLink) {
      productLink.addEventListener('click', (e) => {
        if (didSwipe) {
          e.preventDefault();
          didSwipe = false;
        }
      });
    }
  });
}

